import React from "react";
import LoginRegister from "../Components/Auth/Login&Register";
export default function HomePage() {
  return (
    <>
      <LoginRegister />
    </>
  );
}
